import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { TableData } from 'components/TablesTab/TableData';
import { StatisticsSelects } from 'components/UI/StatisticsSelects';
import { Box, CircularProgress } from '@mui/material';

export const TableTab: React.FC = (): JSX.Element => {
  const { selectLoading } = useAppSelector((state) => state.mainPage);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {selectLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <StatisticsSelects tabType="table" />
          <TableData />
        </>
      )}
    </Box>
  );
};
